"use client";

import { LOGO } from "@/assets";
import Image from "next/image";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "./ui/sheet";
import { useState } from "react";
import { Icons } from "./Icons";
import { buttonVariants } from "./ui/button";
import { cn } from "@/lib/utils";
import UserAccountNav from "./auth/UserAccountNav";
import { useAuth } from "@/stores/auth.store";
import { usePathname } from "next/navigation";
import Link from "next/link";

const menuItems = [

] as any

export default function Navbar() {
  const [sheetOpen, setSheetOpen] = useState(false);
  const { user } = useAuth();

  const handleClickMenu = () => {
    setSheetOpen(false);
  };

  return (
    <nav className="z-10 fixed w-full top-0 flex items-center h-[62px] px-1 sm:px-4 lg:px-10 py-2 bg-white drop-shadow-xl/5 ">
      {/* <Image src={LOGO.src} width={100} height={50} alt="logo" /> */}
      <figure className="md: w-full h-full flex flex-row items-center justify-between pr-2">
        <div className="flex flex-row gap-2 md:hidden">
          {/* mobile menu */}
          <div className="flex flex-row items-center ">
            <Sheet open={sheetOpen} onOpenChange={setSheetOpen}>
              <SheetTrigger className="flex flex-row items-center px-2 rounded ">
                <Icons.hamburgerMenu stroke="white" />
              </SheetTrigger>
              <SheetContent side={"left"} className="bg-white p-0">
                <SheetHeader>
                  <div className="flex flex-row items-center justify-between p-3">
                    <div className="flex flex-row items-center pt-4 px-2">
                      <Link href={"/"} className="p-0">
                        <Image
                          src={LOGO.src}
                          alt="Logo"
                          height={200}
                          width={400}
                          className="max-h-[100px]"
                        />
                      </Link>
                    </div>
                  </div>
                </SheetHeader>
                <hr className="my-4" />
                <ul className="pr-10">
                  {menuItems?.map((item, index) => {
                    {
                      if (item.displayOnSignInOnly && !user) return null;
                    }
                    return (
                      <MobileMenuItem
                        key={index}
                        menu={item}
                        onClickMenu={handleClickMenu}
                      />
                    );
                  })}

                  <MobileMenuItem
                    menu={{
                      name: "project",
                      label: "My Projects",
                      icon: (
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M5.30775 20.5C4.80908 20.5 4.38308 20.3234 4.02975 19.9703C3.67658 19.6169 3.5 19.1909 3.5 18.6923V5.30775C3.5 4.80908 3.67658 4.38308 4.02975 4.02975C4.38308 3.67658 4.80908 3.5 5.30775 3.5H9.75775C9.82058 2.94483 10.0629 2.47275 10.4848 2.08375C10.9064 1.69458 11.4115 1.5 12 1.5C12.5948 1.5 13.1032 1.69458 13.525 2.08375C13.9468 2.47275 14.1859 2.94483 14.2423 3.5H18.6923C19.1909 3.5 19.6169 3.67658 19.9703 4.02975C20.3234 4.38308 20.5 4.80908 20.5 5.30775V18.6923C20.5 19.1909 20.3234 19.6169 19.9703 19.9703C19.6169 20.3234 19.1909 20.5 18.6923 20.5H5.30775ZM5.30775 19H18.6923C18.7692 19 18.8398 18.9679 18.9038 18.9038C18.9679 18.8398 19 18.7693 19 18.6923V5.30775C19 5.23075 18.9679 5.16025 18.9038 5.09625C18.8398 5.03208 18.7692 5 18.6923 5H5.30775C5.23075 5 5.16025 5.03208 5.09625 5.09625C5.03208 5.16025 5 5.23075 5 5.30775V18.6923C5 18.7693 5.03208 18.8398 5.09625 18.9038C5.16025 18.9679 5.23075 19 5.30775 19ZM7.25 16.6345H13.75V15.1348H7.25V16.6345ZM7.25 12.75H16.75V11.25H7.25V12.75ZM7.25 8.86525H16.75V7.3655H7.25V8.86525ZM12 4.34625C12.2167 4.34625 12.3958 4.27542 12.5375 4.13375C12.6792 3.99208 12.75 3.81292 12.75 3.59625C12.75 3.37958 12.6792 3.20042 12.5375 3.05875C12.3958 2.91708 12.2167 2.84625 12 2.84625C11.7833 2.84625 11.6042 2.91708 11.4625 3.05875C11.3208 3.20042 11.25 3.37958 11.25 3.59625C11.25 3.81292 11.3208 3.99208 11.4625 4.13375C11.6042 4.27542 11.7833 4.34625 12 4.34625Z"
                            fill="#613730"
                          />
                        </svg>
                      ),
                      href: "/user/project",
                      displayOnSignInOnly: true,
                    }}
                    onClickMenu={handleClickMenu}
                  />
                </ul>
              </SheetContent>
              <SheetTitle></SheetTitle>
            </Sheet>
          </div>

          <Link
            href="/"
            className="hidden gap-2 items-center text-popover"
          >
            <p className="hidden md:block">
              <Icons.home className="h-10 w-10 md:h-6 md:w-6 " />
            </p>
          </Link>
        </div>
        {/* desktop menu */}
        <div className="hidden whitespace-nowrap w-full sm:text-sm lg:text-lg md:flex flex-row items-center sm:gap-1 lg:gap-10 h-full px-2">
          <Link href={"/"} className="p-0">
            <Image
              src={LOGO.src}
              width={170}
              height={70}
              alt="logo"
              className="h-full translate-1"
            />
          </Link>
          <div className="flex flex-row items-center sm:gap-1 lg:gap-4 h-full w-full ">
            {menuItems?.map((item, index) => {
              {
                if (item.displayOnSignInOnly && !user) return null;
              }
              {
                /* if (item?.hiddinOnSignIn && (user || session?.user)) return null; */
              }
              return <DesktopMenuItem key={index} menu={item} />;
            })}
          </div>
        </div>
        <div className="h-full flex flex-row items-center justify-center gap-1 font-bold sm:text-sm lg:text-lg">
          {!user ? (
            <>
              <Link
                className="w-full flex flex-row items-center text-center justify-center capitalize text-secondary hover:text-primary duration-100 px-1 sm:px-4 py-2 no-underline rounded-md text-nowrap"
                href={"/sign-in"}
              // onClick={onClickMenu}
              >
                Signin
              </Link>

              <Link
                className="w-full sm:min-w-36 flex flex-row items-center text-center justify-center capitalize text-primary hover:text-secondary duration-100 bg-white px-2 py-2 no-underline rounded-2xl text-nowrap"
                href={"/sign-up"}
              // onClick={onClickMenu}
              >
                Signup
              </Link>
            </>
          ) : (
            <>

              <UserAccountNav />
            </>
          )}

        </div>
      </figure>
    </nav>
  );
}

type MenuItemProps = {
  menu: {
    name: string;
    label: string;
    href: string;
    icon: React.ReactNode;
    displayOnSignInOnly: boolean;
    children?: {
      name: string;
      label: string;
      href: string;
      icon: React.ReactNode;
      displayOnSignInOnly: boolean;
    }[];
  };
  onClickMenu?: () => void;
  className?: string;
};

function DesktopMenuItem({ menu }: MenuItemProps) {
  const pathname = usePathname();

  return (
    <Link
      href={menu.href}
      className={cn(
        " items-center text-center text-popover h-full relative ",
        pathname == menu?.href
          ? // ? "border-b-2 border-secondary bg-gradient-to-t from-secondary via-secondary to-transparent rounded-xl bg-opacity-40"
          "after:absolute after:left-0 after:bottom-0 after:w-full after:h-0.5 after:block after:bg-background"
          : "bg-blend-normal",
      )}
    >
      <p
        className={cn(
          buttonVariants({ variant: "link", size: "sm" }),
          "text-md hover:scale-105 transition duration-150 ease-in-out h-full rounded-none font-semibold text-secondary",
          pathname == menu?.href ? "font-bold " : "",
        )}
      >
        {menu?.icon} {menu.name}
      </p>
    </Link>
  );
}

function MobileMenuItem({ menu, onClickMenu }: MenuItemProps) {

  return (
    <li className="my-3 px-5 py-2 rounded-r-full">
      <Link
        className="w-full flex flex-row gap-5 items-center capitalize text-[#613730] text-xl hover:text-primary duration-100"
        href={menu?.href}
        onClick={onClickMenu}
      >
        {menu?.icon}
        {menu?.name == "home" ? "หน้าหลัก" : menu.name}
      </Link>
    </li>
  );
}
